import { breakpoints } from '../ui'

export const getResolutions = (path: string, type: string) => {
  const sources = [
    `${path}_480.${type} 480w`,
    `${path}_768.${type} 768w`,
    `${path}_992.${type} 992w`,
    `${path}_1280.${type} 1280w`,
  ]
  return sources.join(',')
}

export const getImagesListSEO = (url: string, slug: string, imageName: string) => {
  const { name, extension } = fileInParts(imageName)
  const sources = [
    `${url}/images/${slug}/${name}_480.${extension}`,
    `${url}/images/${slug}/${name}_768.${extension}`,
    `${url}/images/${slug}/${name}_992.${extension}`,
    `${url}/images/${slug}/${name}_1280.${extension}`,
  ]
  return sources
}

export const fileInParts = (filename: string) => {
  const parts = filename.split('.')
  return { name: parts[0], extension: parts[1] }
}

export const putImagePath = (image: string, slug: string) => {
  return `/images/${slug}/${image}`
}

export const buildRelativePath = (slug: string) => {
  return `/blog/${slug}/`
}

export const responsiveImage = ( image: string, width: number) => {
    if (width <= breakpoints.sm) return `${image}_${breakpoints.sm}.jpg`
    if (width <=  breakpoints.md) return `${image}_${breakpoints.md}.jpg`
    if (width <=  breakpoints.lg) return `${image}_${breakpoints.lg}.jpg`
    if (width <=  breakpoints.xl) return `${image}_${breakpoints.xl}.jpg`
    if (width <=  breakpoints.xxl) return `${image}_${breakpoints.xxl}.jpg`
    return `${image}_2500.jpg`
  }
